// Tiers are the four editing JOBS. Two vocabularies are live at once: wss
// stamps new rows "Copy"/"Line"/"Developmental"/"Continuity", while every
// review_agents row created before that says "Readability"/"Style"/etc. The
// NUMBER is the identity both share — group and colour by it, never by the
// raw string, or one vocabulary silently disappears from the UI.
const tierStringToNumberMap = {
  Copy: 1,
  Line: 3,
  Developmental: 2,
  Continuity: 4,
  // Chat's margin notes (wss stamps tier="Chat" on chat-flavor annotate_text
  // calls). Own slot so they read as chat notes, not Copy.
  Chat: 5,
  // Legacy — same slots, so old comments keep their colour.
  Readability: 1,
  "Structure and Content": 2,
  "Structure and content": 2,
  Style: 3,
  Advanced: 4,
};

const tierNumberToStringMap = {
  1: "Copy",
  2: "Developmental",
  3: "Line",
  4: "Continuity",
  5: "Chat",
};

const orderedTiers = ["Copy", "Line", "Developmental", "Continuity"];

// Any tier string — either vocabulary, or something unrecognised — to the one
// name the UI groups under. Unknown lands in Copy rather than vanishing.
const canonicalTier = (tier) => tierNumberToStringMap[tierStringToNumberMap[tier] || 1];

export { tierStringToNumberMap, tierNumberToStringMap, orderedTiers, canonicalTier };
